export default "__VITE_ASSET__C0Sa8Zk3__"